import UserAgent from "../../../../uq-ui/helpers/express-useragent";
import {env} from "../../../../../runtimeEnv";
const Bowser = require('bowser');

export function isMediaStreamAvailable() {
  const navigator = window.navigator;
  const userAgent = new UserAgent().parse(navigator.userAgent);
  const browserParser = Bowser.getParser(navigator.userAgent);
  const browser = browserParser.getBrowser();
  const hasMediaDevices = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);
  const isAndroid = userAgent.isAndroid;
  const isChrome = browser.name === 'Chrome';

  const isFlagEnabled = env('REACT_APP_ENABLE_WEBRTC') === 'true';
  return isFlagEnabled && hasMediaDevices && isAndroid && isChrome;
}